// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';

import Sortable from '../Sortable';

import api from '../../api';
import formatDate from '../../utilities/formatDate';

import '../../styles/intake-forms.css';
import '../../styles/files.css';

export default class Forms extends React.Component {

    componentDidMount = async () => {
        const res = await api.get('/form/all');
        if (res && res.forms)
            this.props.setForms(res.forms);
    }

    render = () => {
        return (<div className="settings-content">
            
            <p>
                You can use <strong>forms</strong> to collect information used to either populate document fields or create new documents. You can attach one or more forms to stacks in which users need to be able to effectively enter or validate information attached to documents.
            </p>

            <div style={{ clear: 'both' }} />

            <h2 style={{ paddingLeft: 20, fontWeight: 600, paddingBottom: 0 }}>My Forms<div className="settings-add" onClick={() => this.props.modal("create-form")}>＋ Create new form</div></h2>

            <Sortable
                title={null}
                data={this.props.forms}

                // Default sort
                defaultSortBy="title"
                defaultSortDir={1}

                // Header configuration
                header={{
                    name: {
                        prop: "title",
                        label: "Form Title"
                    },
                    meta: [
                        {
                            prop: "createdOn",
                            label: "Created on",
                            width: 140
                        },
                        {
                            prop: "lastModified",
                            label: "Last Modified",
                            width: 140
                        },
                        {
                            prop: "",
                            label: "",
                            width: 140
                        }
                    ]
                }}

                // Line item renderer
                renderItem={(form, idx, renderMeta) => <div
                    className="forms-list-item"
                    key={idx}
                >
                    <div className="forms-list-name">{form.title}</div>

                    <div className="stack-list-meta">
                        {renderMeta(formatDate(form.createdOn), 140)}
                        {renderMeta(formatDate(form.lastModified), 140)}
                        {renderMeta(<>
                            <div
                                className="forms-list-action"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    this.props.modal('edit-form', { form });
                                }}
                            >Edit</div>
                            <div
                                className="forms-list-action forms-list-action-delete"
                                onClick={async (e) => {
                                    e.stopPropagation();
                                    e.preventDefault();

                                    await this.props.loading();
                                    await api.post("/form/remove", {
                                        formId: form._id
                                    });

                                    // Remove locally
                                    let forms = [ ...this.props.forms ];
                                    const formIdx = forms.findIndex(f => f._id === form._id);

                                    if (formIdx >= 0)
                                        forms.splice(formIdx, 1);

                                    this.props.setForms(forms);
                                    this.props.loaded();
                                }}
                            >Delete</div>
                        </>, 140)}
                    </div>
                </div>}
            />

        </div>);
    }

};